var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6592 9.87837H10.0011L9.76783 9.65344C10.5842 8.70377 11.0757 7.47086 11.0757 6.12965C11.0757 3.13901 8.65154 0.714844 5.6609 0.714844C2.67026 0.714844 0.246094 3.13901 0.246094 6.12965C0.246094 9.12029 2.67026 11.5445 5.6609 11.5445C7.00211 11.5445 8.23502 11.053 9.18469 10.2366L9.40962 10.4698V11.1279L13.5749 15.2848L14.8161 14.0436L10.6592 9.87837ZM5.6609 9.87837C3.58661 9.87837 1.91219 8.20394 1.91219 6.12965C1.91219 4.05536 3.58661 2.38094 5.6609 2.38094C7.73519 2.38094 9.40962 4.05536 9.40962 6.12965C9.40962 8.20394 7.73519 9.87837 5.6609 9.87837Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.5e0b81d85a0c57397b96dff760a038d1.svg";
export { ForwardRef as ReactComponent };